import _ from "lodash";
import React from "react";
import classes from "./ResourceView.scss";
import { connect } from "react-redux";
import MiddlePane from "./components/MiddlePane";
import ScreenBaseComponent from "AppComponents/ScreenBaseComponent";
import CommentBoxV2 from "AppComponents/CommentBoxV2";
import CommentBox from "AppComponents/CommentBox";
import { DSProvider } from "@toddle-edu/ds-web";
import {
  isUnitPlanEditPermission,
  getPlannerFieldMutationParams,
} from "UnitPlans/modules/UnitPlanModule";
import { updateNavigationObject } from "modules/NavigationModule";
import MetaTags from "UIComponents/MetaTags";
import MediaModal from "UIComponents/MediaModal";
import { getRethumbUrl, scrollToWithAnimation } from "Utils";
import { GetLESteps } from "Utils/GetLESteps";
import classNames from "classnames";
import { recordEvent } from "lib/eventTracker";
import { startTimer, stopTimer } from "lib/timeTracker";
import { updateField } from "modules/FieldUpdateThunks";
import { compose } from "lib/apolloClient";
import ACLStore from "lib/aclStore";
// TODO: Named imports( putting in {} ) is causing withQueryParamsBasedInterface undefined
import withQueryParamsBasedInterface from "UIComponents/QueryParamsBasedInterfaceHOC";

import { updateAssessmentTemplate } from "Assessments/modules/Utils";

import { updateAssessmentInRedux } from "Assessments/modules/AssessmentModule";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";

export const getResourceViewProps = ({
  sourceType,
  ownProps: { viewSteps },
}) => {
  let sourceTypeBasedConfig = {};

  switch (sourceType) {
    case "SNP":
      sourceTypeBasedConfig = {
        viewSteps: _.without(viewSteps, "teacherNotes"),
        middlePaneProps: {
          showFooter: false,
          showBackButton: false,
          showViewActions: false,
        },
      };
      break;
    default:
      sourceTypeBasedConfig = {};
  }

  return sourceTypeBasedConfig;
};

class ResourceView extends ScreenBaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      currentStep: "",
      showMediaModal: false,
    };
    this.middlePane = null;
    this.stepsRefs = {};
    this.canCurrentStepUpdate = true;
    this.resourceViewRef = React.createRef();
  }

  UNSAFE_componentWillMount = () => {
    const { updateAssessmentInRedux, assessmentId } = this.props;
    updateAssessmentInRedux({
      assessmentId,
    });
  };

  componentDidMount() {
    this.checkCurrentStep();
    const {
      resourceId,
      isCommunity,
      resourceDetails,
      location,
      showAssessmentCommentBox,
    } = this.props;
    const { title } = resourceDetails || {};
    const titleValue = _.get(title, "value", "");

    if (isCommunity) {
      recordEvent({
        eventName: "Viewed learning experience",
        eventData: {
          entity_type: "ASSESSMENT",
          entity_id: resourceId,
          source: "community",
          entity_name: titleValue,
          target: _.get(location, "query.target", undefined),
        },
      });
      startTimer({
        page_name: "learning experience",
      });
    }

    if (!_.isNil(showAssessmentCommentBox)) {
      this.doNotificationTask();
    }
  }

  doNotificationTask = () => {
    const { showAssessmentCommentBox, updateNavigationObject } = this.props;
    if (showAssessmentCommentBox) {
      this.onCommentClick();
    }

    updateNavigationObject({ showAssessmentCommentBox: null });
  };

  componentWillUnmount() {
    const { resourceId, isCommunity, resourceDetails, location } = this.props;
    const { title } = resourceDetails || {};
    const titleValue = _.get(title, "value", "");

    if (isCommunity) {
      recordEvent({
        eventName: "Viewed learning experience",
        eventData: {
          entity_type: "ASSESSMENT",
          entity_id: resourceId,
          source: "community",
          entity_name: titleValue,
          target: _.get(location, "query.target", undefined),
        },
      });
      stopTimer({
        page_name: "learning experience",
        entity_id: resourceId,
        entity_type: "ASSESSMENT",
        entity_name: titleValue,
        target: _.get(location, "query.target", undefined),
      });
    }
  }

  onMiddlePaneScroll = () => {
    this.checkCurrentStep();
  };

  setCurrentStep = step => {
    this.setState({ currentStep: step });
  };

  checkCurrentStep = () => {
    const scrollContainer = this.middlePane.container;
    let currentSection = null;
    if (scrollContainer) {
      _.map(this.stepsRefs, (ref, key) => {
        if (ref) {
          const { top } = ref.getBoundingClientRect();
          if (top < scrollContainer.clientHeight / 4) {
            currentSection = key;
          }
        }
      });
    }
    if (this.state.currentStep != currentSection && this.canCurrentStepUpdate) {
      this.setCurrentStep(currentSection);
    }
  };

  onClickStep = step => {
    const scrollContainer = this.middlePane.container;
    const stepNode = this.stepsRefs[step];
    this.canCurrentStepUpdate = false;
    if (scrollContainer && stepNode) {
      const top = stepNode.offsetTop - scrollContainer.offsetTop + 4;

      scrollToWithAnimation(scrollContainer, top);
    }
    setTimeout(() => {
      this.setCurrentStep(step);
      this.canCurrentStepUpdate = true;
    }, 300);
  };

  getRightPaneComponent = () => {
    const { resourceId, parentType, resourceDetails } = this.props;
    const { currentRightPane } = this.state;
    switch (currentRightPane) {
      case "comment":
        return ACLStore.can("FeatureFlag:ProjectCommentBox") ? (
          // TODO: remove when chatbar supports DS 2.0
          <DSProvider dsVersion="1.0">
            <CommentBoxV2
              parentType={parentType}
              nodeId={resourceId}
              type={parentType}
              commentBoxContainerStyle={{ minHeight: 70 }}
              onClose={this.onCommentClick}
              collaborators={_.get(
                resourceDetails,
                "unitPlan.collaborators",
                []
              )}
              isRightPaneChat={true}
            />
          </DSProvider>
        ) : (
          <CommentBox
            parentType={parentType}
            nodeId={resourceId}
            type={parentType}
            headerStyle={{ border: "none" }}
            feedStyle={{ paddingTop: 0 }}
            commentBoxContainerStyle={{ minHeight: 70 }}
            onClose={this.onCommentClick}
            collaborators={_.get(resourceDetails, "unitPlan.collaborators", [])}
            isRightPaneChat={true}
          />
        );
    }
    return null;
  };

  onCommentClick = () => {
    this.handleRightPane({ rightPane: "comment" });
  };

  setStepsRef = ({ ref, key }) => {
    this.stepsRefs[key] = ref;
  };

  toggleMediaModal = value => {
    this.setState({ showMediaModal: value });
  };

  handleBack = params => {
    const { onClose } = this.props;
    onClose(params);
  };

  updateField = ({
    params,
    isMutation = false,
    isDebounce = true,
    hasAddRemoveValues = false,
    extraParams = {},
  }) => {
    const {
      portalType,
      resourceFields,
      updateFieldInCache,
      updateField,
      t,
    } = this.props;
    _.map(params, (obj, key) => {
      const fieldObj = _.find(resourceFields, { uid: key }) || {};

      const { id } = fieldObj;
      let { value: oldValue } = fieldObj;
      const value = { id, value: obj };
      const shouldUpdate = true;
      switch (key) {
        case "tags":
          oldValue = _.map(
            _.get(fieldObj, "resolvedMinimalTree.tags", []),
            item => item.id
          );
          break;
      }

      if (shouldUpdate) {
        updateFieldInCache({
          fieldUID: key,
          params: { ...value, uid: key },
          fieldObj,
          extraParams,
        });
        const mutationParams = getPlannerFieldMutationParams({
          id,
          fieldUID: key,
          oldValue,
          hasAddRemoveValues,
          newValue: obj,
        });
        if (isMutation) {
          updateField({
            key: id,
            params: { ...(mutationParams || {}), portalType },
            type: this.props.parentType,
            isDebounce,
            t,
          });
        }
      }
    });
  };

  render() {
    const {
      userType,
      resourceDetails,
      template,
      resourceFields,
      resourceId,
      unitPlanFields,
      benchmarkSet,
      onClickEdit,
      parentType,
      onClickPrint,
      showRightPane,
      isUnitPlanEditPermission,
      unitPlanId,
      view_steps,
      step_list,
      isLocalisedTemplate,
      field_list,
      isCommunity,
      isToddleLibrary,
      tags,
      userLoggedIn,
      curriculumProgram,
      curriculumType,
      middlePaneProps,
      localisedTemplateId,
      isDemo,
      assessmentTools,
      assessmentType,
      taskTypeGroup,
      plannerElements,
      isAssessmentLoading,
      subscribeToddleLibraryEvents,
      unSubscribeToddleLibraryEvents,
      testId = "resourceView",
      learningCourseId,
      unitCourseId,
    } = this.props;
    const { currentRightPane, showMediaModal } = this.state;

    const isEditPermission = isUnitPlanEditPermission({ unitPlanId });
    const image = _.get(
      _.find(resourceFields, field => _.get(field, "uid") === "image"),
      "value",
      ""
    );
    const isDownloadEnabled = !ACLStore.can(
      "FeatureFlag:PreventPrintAndScreenshots"
    );

    const containerWrapperClasses = classNames(
      { [classes.containerWrapper]: true },
      { [classes.containerWithoutRightPane]: !isCommunity || !isToddleLibrary }
    );

    const rethumpUrl = image
      ? `url(${getRethumbUrl({
          width: 512,
          height: 384,
          imageUrl: image,
          fitIn: true,
        })})`
      : image;

    const resourceTitle = _.get(resourceDetails, "title.value", "");
    const resourceImage = _.get(resourceDetails, "image.value", "");

    return (
      <div className={containerWrapperClasses} ref={this.resourceViewRef}>
        <div className={classes.container}>
          <MiddlePane
            userType={userType}
            isCommunity={isCommunity}
            isToddleLibrary={isToddleLibrary}
            field_list={field_list}
            step_list={step_list}
            view_steps={view_steps}
            localisedTemplateId={localisedTemplateId}
            isLocalisedTemplate={isLocalisedTemplate}
            setStepsRef={this.setStepsRef}
            showRightPane={showRightPane}
            parentType={parentType}
            resourceId={resourceId}
            onClickPrint={onClickPrint}
            ref={ref => (this.middlePane = ref)}
            onCommentClick={this.onCommentClick}
            resourceDetails={resourceDetails}
            totalCommentCount={_.get(resourceDetails, "comments.totalCount", 0)}
            unreadCommentCount={_.get(
              resourceDetails,
              "comments.unreadCount",
              0
            )}
            template={template}
            resourceFields={resourceFields}
            benchmarkSet={benchmarkSet}
            currentRightPane={currentRightPane}
            isEditPermission={isEditPermission}
            onClickEdit={onClickEdit}
            onScroll={this.onMiddlePaneScroll}
            unitPlanFields={unitPlanFields}
            rethumpUrl={rethumpUrl}
            toggleMediaModal={this.toggleMediaModal}
            image={image}
            parentRef={this.resourceViewRef}
            onClose={this.handleBack}
            tags={tags}
            updateField={this.updateField}
            userLoggedIn={userLoggedIn}
            curriculumProgram={curriculumProgram}
            curriculumType={curriculumType}
            isDemo={isDemo}
            assessmentTools={assessmentTools}
            assessmentType={assessmentType}
            taskTypeGroup={taskTypeGroup}
            plannerElements={plannerElements}
            isAssessmentLoading={isAssessmentLoading}
            subscribeToddleLibraryEvents={subscribeToddleLibraryEvents}
            unSubscribeToddleLibraryEvents={unSubscribeToddleLibraryEvents}
            testId={testId}
            isDownloadEnabled={isDownloadEnabled}
            learningCourseId={learningCourseId}
            unitCourseId={unitCourseId}
            {...middlePaneProps}
          />
          {currentRightPane && this.renderRightPane()}

          {showMediaModal && (
            <MediaModal
              canDownloadMedia={
                !ACLStore.can("FeatureFlag:PreventPrintAndScreenshots")
              }
              toggleMediaModal={this.toggleMediaModal}
              attachments={[{ url: image, type: "IMAGE" }]}
            />
          )}
          <MetaTags
            title={resourceTitle}
            image={resourceImage}
            url={window.location.href}
          />
        </div>
      </div>
    );
  }
}

const mapActionCreators = {
  isUnitPlanEditPermission,
  updateField,
  updateAssessmentInRedux,
  updateNavigationObject,
};

const getTags = ({ resourceDetails }) => {
  const tags = _.get(
    _.find(
      _.get(resourceDetails, "allFields", []),
      item => _.get(item, "uid") == "tags"
    ),
    "resolvedMinimalTree.tags",
    []
  );
  return _.map(tags, item => {
    const { id, label } = item || {};
    return { id, value: id, label, __typename: "TOPIC", type: "TOPIC" };
  });
};

const mapStateToProps = (state, ownProps) => {
  const {
    t,
    assessmentType,
    resourceFields = [],
    template: originalTemplate,
    resourceDetails,
    unitPlanFields,
    subjects,
    courseSubjects,
    taskTypeGroup,
  } = ownProps;

  const userInfo = getUserInfo();
  const userType = _.get(userInfo, "user_type", "");

  const { userLoggedIn } = state.login;
  const activeTab = state.login.activeTab;
  const isCommunity = activeTab == "community";
  const isToddleLibrary = activeTab == "TODDLE_LIBRARY";
  const selected_class = state.teacher.selected_class;

  const { type: curriculumType } = state.platform.currentCurriculumProgram;

  const template = updateAssessmentTemplate({
    t,
    template: originalTemplate,
    assessmentType,
    taskTypeGroup,
    isFromClassroom: false,
    curriculumType,
    resourceFields,
    mode: "view",
    plannerElementSets: _.get(state, "platform.currentPlannerElementSets", []),
    subjects: !_.isEmpty(subjects) ? subjects : courseSubjects,
    userType,
    assessmentTools: _.get(ownProps, "assessmentTools", []),
  });

  const listSteps = GetLESteps({
    userType,
    template,
    resourceDetails,
    unitPlanFields,
    isPreview: false,
    isCommunity,
    isToddleLibrary,
    curriculumProgramType: curriculumType,
  });
  const { stepList } = listSteps;
  let { viewSteps } = listSteps;
  if (!userLoggedIn) {
    viewSteps = _.slice(viewSteps, 0, 2);
  }

  const showAssessmentCommentBox =
    state.navigation.navigationObject.showAssessmentCommentBox;
  return {
    userType,
    isCommunity,
    isToddleLibrary,
    step_list: stepList,
    view_steps: viewSteps,
    field_list: _.get(template, "field_list", {}),
    isLocalisedTemplate: _.get(template, "isLocalisedTemplate", true),
    localisedTemplateId: _.get(template, "localisedTemplateId", ""),
    tags: getTags({ resourceDetails }),
    userLoggedIn,
    isDemo: selected_class.isDemo,
    showAssessmentCommentBox,
  };
};

export default compose(
  connect(mapStateToProps, mapActionCreators),
  withQueryParamsBasedInterface({ cb: getResourceViewProps })
)(ResourceView);
